import React from 'react';
import {
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
} from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import { WifiProfile } from '../../stores/TelematicsDevice/DeviceStateApi';
import '../DeviceState/StateStatus.scss';

type SavedNetworksListProps = {
  profiles: WifiProfile[];
  reportedSsids: Set<string>;
  profilesToRemove: string[];
  onRemove: (ssid: string) => void;
  onUndoRemove: (ssid: string) => void;
};

export const SavedNetworksList: React.FC<SavedNetworksListProps> = ({
  profiles,
  reportedSsids,
  profilesToRemove,
  onRemove,
  onUndoRemove,
}) => {
  if (profiles.length === 0) {
    return null;
  }

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Saved networks
      </Typography>
      <List>
        {profiles.map((profile) => {
          const isMarkedForRemoval = profilesToRemove.includes(profile.ssid);
          const isProfilePending = !reportedSsids.has(profile.ssid);
          const secondaryText = isMarkedForRemoval
            ? 'Marked for removal'
            : `${profile.securityType || 'Automatic security'}`;

          return (
            <ListItem
              key={profile.ssid}
              style={{
                backgroundColor: isMarkedForRemoval ? '#ffebee' : undefined,
                textDecoration: isMarkedForRemoval ? 'line-through' : undefined,
              }}
            >
              <ListItemText primary={profile.ssid} secondary={secondaryText} />
              {isProfilePending && !isMarkedForRemoval && (
                <div className="state">
                  <div className="pending"><div>pending</div></div>
                </div>
              )}
              <ListItemSecondaryAction>
                {isMarkedForRemoval ? (
                  <Button size="small" onClick={() => onUndoRemove(profile.ssid)}>
                    Undo
                  </Button>
                ) : (
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    onClick={() => onRemove(profile.ssid)}
                  >
                    <Delete />
                  </IconButton>
                )}
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>
    </>
  );
};
